(function () {
  const STORAGE_KEY = 'chutty-collection-grid-view';

  const columnMap = {
    'cols-2': { desktop: 2, tablet: 2, mobile: 2 },
    'cols-3': { desktop: 3, tablet: 3, mobile: 2 },
    'cols-4': { desktop: 4, tablet: 3, mobile: 2 },
    list: { desktop: 1, tablet: 1, mobile: 1 },
  };

  function applyGridView(view) {
    const collection = document.querySelector('.chutty-collection');
    const grid = collection?.querySelector('.chutty-collection__grid');
    if (!collection || !grid) return;

    const cols = columnMap[view] || columnMap['cols-4'];
    collection.style.setProperty('--chutty-cols-desktop', String(cols.desktop));
    collection.style.setProperty('--chutty-cols-tablet', String(cols.tablet));
    collection.style.setProperty('--chutty-cols-mobile', String(cols.mobile));
    grid.classList.toggle('chutty-collection__grid--list', view === 'list');
    grid.dataset.gridView = view;
  }

  function syncControls(view) {
    document.querySelectorAll('[data-chutty-grid-option]').forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      input.checked = input.value === view;
    });
  }

  function init() {
    const saved = sessionStorage.getItem(STORAGE_KEY) || 'cols-4';
    applyGridView(saved);
    syncControls(saved);

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (!target.matches('[data-chutty-grid-option]')) return;

      applyGridView(target.value);
      sessionStorage.setItem(STORAGE_KEY, target.value);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
